
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M21.782 25.165c-.03.226-.274.423-.608.423H9.796c-.303 0-.577-.197-.608-.423L7.915 7.009h15.171l-1.304 18.156zM12.163 4.41h6.798l.211 1.159h-7.22l.211-1.16zM26.242 5.57h-5.523l-.272-1.554C20.327 3.423 19.78 3 19.142 3h-7.19c-.64 0-1.186.423-1.275 1.016l-.274 1.554H4.76c-.426 0-.76.31-.76.705 0 .394.334.705.76.705h1.638l1.304 18.27c.06.988 1.002 1.75 2.094 1.75h11.41c1.122 0 2.032-.762 2.092-1.75l1.306-18.27h1.638c.425 0 .758-.31.758-.705 0-.396-.333-.705-.758-.705z"}}),_c('path',{attrs:{"d":"M15.5 23c.216 0 .393-.233.393-.52V10.52c0-.287-.178-.52-.394-.52-.216 0-.392.233-.392.52v11.96c0 .287.177.52.393.52M19.318 23c.2 0 .332-.208.349-.494L20 10.545c0-.285-.134-.52-.316-.545-.184 0-.333.208-.35.493l-.333 11.96c-.017.287.134.547.317.547M11.667 23c.2 0 .333-.26.333-.546l-.333-11.959c0-.285-.166-.52-.35-.493-.182 0-.333.26-.316.545l.333 11.959c0 .286.15.494.333.494"}})])])
          )
        }
      }
    